import { Directive, ElementRef, HostListener, OnDestroy, Renderer2, booleanAttribute, inject, input, output } from '@angular/core';

import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';

@Directive({ selector: '[fileDrop]' })
export class FileDropDirective implements OnDestroy {
    fileDropEnabled = input<boolean, unknown>(true, { transform: booleanAttribute });
    fileOver = output<boolean>();
    fileDrop = output<File[]>();

    isFileOverUpdate: Subject<boolean> = new Subject();
    isFileOverSubscription = this.isFileOverUpdate.pipe(distinctUntilChanged(), debounceTime(200)).subscribe((v) => {
        if (this._elRef) {
            if (v) {
                this._r2.addClass(this._elRef.nativeElement, 'fileDrop-file-over');
            }
            else {
                this._r2.removeClass(this._elRef.nativeElement, 'fileDrop-file-over');
            }
        }
        this.fileOver.emit(v);
    });

    @HostListener('drop', ['$event'])
    onDrop(event: DragEvent) {
        if (!this.fileDropEnabled()) {
            return;
        }
        const transfer = this._getTransfer(event);
        if (!transfer) {
            return;
        }
        if (transfer.files && transfer.files.length > 0) {
            event.preventDefault();
            this.fileDrop.emit(transfer.files as any);
        }
        this.isFileOverUpdate.next(false);
    }

    @HostListener('dragover', ['$event'])
    onDragOver(event: DragEvent) {
        if (!this.fileDropEnabled()) {
            return;
        }
        const transfer = this._getTransfer(event);
        if (!transfer || !this._haveFiles(transfer.types)) {
            return;
        }

        transfer.dropEffect = 'copy';
        event.preventDefault();

        this.isFileOverUpdate.next(true);
    }

    @HostListener('dragleave', ['$event'])
    onDragLeave(event: DragEvent): any {
        event.preventDefault();
        this.isFileOverUpdate.next(false);
    }

    readonly _r2 = inject(Renderer2);
    readonly _elRef = inject(ElementRef);

    ngOnDestroy(): void {
        this.isFileOverSubscription?.unsubscribe();
    }

    private _getTransfer(event: DragEvent): DataTransfer | undefined {
        return event.dataTransfer ? event.dataTransfer : (event as any).originalEvent?.dataTransfer;
    }

    private _haveFiles(types: any): any {
        if (!types) {
            return false;
        }
        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        }
        else if (types.contains) {
            return types.contains('Files');
        }
        return false;
    }

}
